import { ITooltipSizeEnum } from "@molecules/tooltip/types";

import type { IFontType } from "@interfaces";

export const getTooltipTitleFontType = (size: ITooltipSizeEnum): IFontType => {
  if (size === ITooltipSizeEnum.Large) return "label-small";
  if (size === ITooltipSizeEnum.X_Small) return "paragraph-small";
  return "paragraph-x-small";
};
